import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { getPreferences, submitPreferences } from '../action';
import SmallButton from 'modules/Content/Shared/SmallButton';
import PreferenceBox from './PreferenceBox';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { useParams } from 'react-router-dom';

function PreferencesList(props: any) {
  const history = useNavigate();

  useEffect(() => {
    getPreferences(unsubid).then(() => {
      setSubmitDisabled(false);
    });
  }, []);
  const { unsubid } = useParams();

  let preferenceManagementState = useSelector((state: RootState) => state.preferenceManagement);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const prefOrder = ['marketing', 'alerts', 'news_letters', 'webinars', 'unsub_all'];
  const PrefBoxLoading = useSelector((state: RootState) => state.preferenceManagement.loading);
  const pref: { [key: string]: any } = {
    webinars: {
      status: 0,
      heading: 'Webinars/Events',
      description: 'Get notified about xiQ’s events and webinars, such as product demos and workshops.',
      options: false,
    },
    marketing: {
      status: 0,
      heading: 'Marketing',
      description: 'Stay updated on how our product is constantly evolving.',
      options: false,
    },
    alerts: {
      status: 0,
      heading: 'Alerts',
      description: 'Daily email alerts on your accounts and CxOs, updates on top industry news, and more.',
      options: true,
    },
    unsub_all: {
      status: 0,
      heading: 'Unsubscribe All',
      description: 'No longer receive any emails.',
    },
    news_letters: {
      status: 0,
      heading: 'Digests/Newsletters',
      description:
        'Get our latest curated articles, sales triggers news, and business advice delivered to your inbox every week.',
    },
  };

  const areAllChecksOff = () => {
    let ticksCount = 0;
    Object.keys(preferenceManagementState).forEach((key: any) => {
      if (preferenceManagementState[key]) {
        if (key === 'alerts' || key === 'news_letters') {
          preferenceManagementState[key].forEach((item: any) => {
            if (item.status === '1') {
              ticksCount += 1;
            }
          });
        } else {
          if (preferenceManagementState[key] === '1') {
            ticksCount += 1;
          }
        }
      }
    });
    return ticksCount === 0;
  };

  return (
    <>
      {PrefBoxLoading ? <p>Loading...</p> : null}
      {!PrefBoxLoading
        ? prefOrder.map((key) => {
            if (pref[key] && preferenceManagementState[key]) {
              if (key === 'news_letters' || key === 'alerts') {
                if (preferenceManagementState[key].length > 0) {
                  return (
                    <div className="preference-box">
                      <PreferenceBox
                        objectKey={key}
                        heading={pref[key]?.heading}
                        description={pref[key]?.description}
                        {...(key === 'news_letters' || key === 'alerts'
                          ? {
                              options: preferenceManagementState[key],
                            }
                          : {})}
                        checked={preferenceManagementState[key] === '1'}
                      />
                    </div>
                  );
                }
              } else {
                return (
                  <div className="preference-box">
                    <PreferenceBox
                      objectKey={key}
                      heading={pref[key]?.heading}
                      description={pref[key]?.description}
                      {...(key === 'news_letters'
                        ? {
                            options: preferenceManagementState[key],
                          }
                        : {})}
                      checked={preferenceManagementState[key] === '1'}
                    />
                  </div>
                );
              }
            }
            return;
          })
        : null}
      <div className="button">
        <SmallButton
          title="Submit"
          outline={`btn ${submitDisabled || areAllChecksOff() ? 'disabled' : ''}`}
          onClick={() => {
            setSubmitDisabled(true);
            submitPreferences()
              .then(() => {
                history('/unsub-success');
              })
              .catch(() => {
                message.error('Failed in updating the preferences !');
              });
          }}
        />
      </div>
    </>
  );
}

export default PreferencesList;
